import { useContext } from 'react';
import { Row, Col } from 'reactstrap';
import PageContainer from 'common/PageContainer';
import logo from 'images/user.png';
import PageLoader from 'common/PageLoader';
// import NoData from "common/NoData";
import { UsersContextDetail } from './userContextDetail';
import { RenderBookingDetails } from './components/Booking';
import Header from 'components/Header';
import StatusComponent from './components/CustomerStatus';
import moment from 'moment';
const CustomerDetail = () => {
  const context = useContext(UsersContextDetail);
  if (!context) {
    throw new Error('UsersContext must be used within a UsersProvider');
  }
  const {
    userDetail: { isLoading: userLoading, status, error, data },
    userBookings: {
      isLoading: bookingLoading,
      status: bookingStatus,
      error: bookingError,
      data: bookingData,
    },
  } = context;

  // Combine loading states
  const isLoading = userLoading || bookingLoading;

  console.log('data===>', data);

  const renderCustomerDetails = () => {
    console.log('renderCustomerDetails called!!!', bookingData);

    return (
      <Row>
        <Col xs="10" md="2">
          <img
            src={logo || data.image}
            alt="User"
            className="mt-3 ms-4 img-fluid rounded-circle"
            style={{ height: '150px', width: '150px', objectFit: 'cover' }}
          />
        </Col>
        <Col>
          <Row>
            <Col md="2" className="pt-3">
              <h6 className="mb-0 adminLabel">Name</h6>
              <span className="mb-2 adminDetail">
                {data?.firstName
                  ? data?.firstName.charAt(0).toUpperCase() +
                    data.firstName.substring(1)
                  : 'N/A'}{' '}
                {data?.lastName
                  ? data.lastName.charAt(0).toUpperCase() +
                    data.lastName.substring(1)
                  : ''}
              </span>
            </Col>
            <Col md="2" className="pt-3">
              <h6 className="mb-0 adminLabel">Date of birth</h6>
              <span className="mb-2 adminDetail">
                {data.dateOfBirth
                  ? moment(data.dateOfBirth, 'DD-MM-YYYY').format('DD/MM/YYYY')
                  : 'N/A'}
              </span>
            </Col>
            <Col md="2" className="pt-3">
              <h6 className="mb-0 adminLabel">Gender</h6>
              <span className="mb-2 adminDetail">{data.gender || 'N/A'}</span>
            </Col>
          </Row>
          <Row>
            <Col md="2" className="pt-3">
              <h6 className="mb-0 adminLabel mt-3">Email</h6>
              <span className="mb-2 adminDetail">{data.email || 'N/A'}</span>
            </Col>
            <Col md="2" className="pt-3">
              <h6 className="mb-0 adminLabel mt-3">Phone</h6>
              <span className="mb-2 adminDetail">{data.phone}</span>
            </Col>
            <Col md="2" className="pt-3">
              <StatusComponent
                customerId={data.id}
                initialStatus={
                  data?.status === 1
                    ? 'Active'
                    : data?.status === 0
                    ? 'Deactivate'
                    : 'N/A'
                }
                onUpdate={(newStatus: any) => {
                  console.log('Updated status.......:', newStatus);
                }}
                role={data.role}
              />
            </Col>
          </Row>
          <Row>
            <Col xs="4">
              <h6 className="mb-0 adminLabel mt-2">Address</h6>
              <span className="mb-2 adminDetail">{data.address || 'N/A'}</span>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };
  if (isLoading) return <PageLoader />;
  if (error) {
    return <span>Something went wrong!</span>;
  }
  if (status === 200 && !data) return <span>No data found!</span>;
  if (status === 200) {
    return (
      <PageContainer>
        <Header totalCount={null} heading={'Customer Details'} />
        {renderCustomerDetails()}
        <RenderBookingDetails
          bookingData={bookingData}
          bookingLoading={bookingLoading}
          bookingError={bookingError}
          bookingStatus={bookingStatus}
        />
      </PageContainer>
    );
  }
  return null;
};

export default CustomerDetail;
